module.exports = __webpack_public_path__ + "img/data-3.ab1910c5.png";